var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.loading,
          expression: "loading"
        }
      ],
      staticClass: "v-spinner"
    },
    [
      _c("div", { staticClass: "v-moon v-moon1", style: _vm.spinnerStyle }, [
        _c("div", {
          staticClass: "v-moon v-moon2",
          style: [_vm.spinnerMoonStyle, _vm.animationStyle2]
        }),
        _c("div", {
          staticClass: "v-moon v-moon3",
          style: [_vm.spinnerStyle, _vm.animationStyle3]
        })
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./node_modules/vue-spinner/src/MoonLoader.vue?vue&type=template&id=4fa7fc7a&
// module id = null
// module chunks = 